<template>
  <transition name="modal">
    <div class="modal-mask" v-if="item.name">
      <div class="modal-wrapper" @click="close($event)">
        <div class="modal-container">
          <div class="modal-header">

            <h3>{{ item.name }}</h3>
            <button type="button" class="btn-close-modal" @click="close()">×</button>
          </div>
          <div class="modal-body">
            <div>
              <div class="catalog catalog_view_detail">
                <div class="catalog__product-info product product_view_card">
                  <div class="product__content-inner">

                    <div class="product__picture">

                      <div class="product__picture-slider js-slider-preview-product-withThumb">
                        <div class="product__picture-slider-main" data-slider="main">

                          <template v-if="item.images.large && item.images.large.length > 0">
                            <vue-swiper :images="item.images.large" :key="item.id"></vue-swiper>
                          </template>
                          <template v-else>
                            <div class="thumb-image img-content">
                              <img src="/img/empty-600.png">
                            </div>
                          </template>

                        </div>
                        <div class="product__picture-slider-thumbs">

                        </div>
                      </div>

                    </div>

                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </transition>

</template>
<script>
import VueSwiper from "./VueSwiper.vue";

export default {
  name: 'modalImages',
  data: function () {
    return {
      showModal: false,
      back_url: window.btoa(this.$route.path),
    }
  },
  props: {
    item: {
      type: Object,
      default: function () {
        return {}
      }
    },
  },

  methods: {
    close(event) {
      this.$emit('close', event);
    },
  },
  components: {
    VueSwiper,
  }
};
</script>
<style scoped>
.modal-mask {
  display: block;
  overflow: scroll;
}
@media screen and (min-width: 1019px) {
  .modal-container {
    width: 700px;
  }
}
@media screen and (max-width: 1019px) {
  .modal-container {
    width: 90%;
  }
}
.modal-wrapper {
  display: block;
}
.modal-body{
  display: grid;
  place-items: center;
}
</style>